// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

const ProofDetailsActionTypes = {
	// ADD BUSINESS PROOF RESPONSE
	ADD_BUSINESS_PROOF_START: 'add_business_poof_start',
	ADD_BUSINESS_PROOF_SUCCESS: 'add_business_poof_success',
	ADD_BUSINESS_PROOF_FAILURE: 'add_business_poof_failure',
	ADD_BUSINESS_PROOF_RESPONSE_RESET: 'add_business_poof_response_reset',
	ADD_BUSINESS_PROOF_RESPONSE_CHANGED: 'add_business_poof_response_changed',

	// UPDATE BUSINESS PROOF RESPONSE
	UPDATE_BUSINESS_PROOF_START: 'update_business_poof_start',
	UPDATE_BUSINESS_PROOF_SUCCESS: 'update_business_poof_success',
	UPDATE_BUSINESS_PROOF_FAILURE: 'update_business_poof_failure',
	UPDATE_BUSINESS_PROOF_RESPONSE_RESET: 'update_business_poof_response_reset',
	UPDATE_BUSINESS_PROOF_RESPONSE_CHANGED: 'update_business_poof_response_changed',

	// FETCH BUSINESS PROOF REPONSE
	FETCH_BUSINESS_PROOF_START: 'fetch_business_poof_start',
	FETCH_BUSINESS_PROOF_SUCCESS: 'fetch_business_poof_success',
	FETCH_BUSINESS_PROOF_FAILURE: 'fetch_business_poof_failure',
	FETCH_BUSINESS_PROOF_RESPONSE_RESET: 'fetch_business_poof_response_reset',
	FETCH_BUSINESS_PROOF_RESPONSE_CHANGED: 'fetch_business_poof_response_changed',

	// DELETE BUSINESS PROOF REPONSE
	DELETE_BUSINESS_PROOF_START: 'delete_business_poof_start',
	DELETE_BUSINESS_PROOF_SUCCESS: 'delete_business_poof_success',
	DELETE_BUSINESS_PROOF_FAILURE: 'delete_business_poof_failure',
	DELETE_BUSINESS_PROOF_RESPONSE_RESET: 'delete_business_poof_response_reset',
	DELETE_BUSINESS_PROOF_RESPONSE_CHANGED: 'delete_business_poof_response_changed',
};
export default ProofDetailsActionTypes;
